import React from "react";

const Rectangle = (props) => {
  const viewBoxWidth = 85;
  const viewBoxHeight = 86;

  const lengthXPrcnt = 0.38;
  const lengthYPrcnt = 0.15;

  const widthXPrcnt = 0.55;
  const widthYPrcnt = 0.43;

  const lengthX = lengthXPrcnt * viewBoxWidth;
  const lengthY = lengthYPrcnt * viewBoxHeight;

  const widthX = widthXPrcnt * viewBoxWidth;
  const widthY = widthYPrcnt * viewBoxHeight;

  const x = (percentX) => percentX * viewBoxWidth;
  const y = (percentY) => percentY * viewBoxHeight;

  const lineColor = "#4a4a4a";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={"-1.696 0 " + viewBoxWidth + " " + viewBoxHeight}
      width={props.width}
      height={props.height}
      preserveAspectRatio={props.preserveAspectRatio}
      style={props.style}
      {...props}
    >
      <path
        className="st0"
        fill={props.color || "#000"}
        d="M67.1,1.2s0,0,0,0c0-.2-.2-.3-.3-.3,0,0-46.1,0-46.2,0,0,0-.1,0-.2.2,0,.2,0,83.6,0,83.6,0,.1,0,.2.2.2.2.1,46.3.1,46.4,0,.3-.2.2,5.6.2-83.7ZM66.2,83.6c-1.3-1.3-3.7-3.7-5-5V7.2l5-5v81.4ZM21.1,2.2c1.3,1.3,3.7,3.7,5,5v71.4l-5,5V2.2ZM59.9,7.4c-.8.8-2.2,2.2-2.9,2.9h-26.6l-2.9-2.9h32.4ZM30.6,74.7V11.2h26.1v63.5h-26.1ZM26.9,77.8V8l2.9,2.9v64c-.7.7-2.2,2.2-2.9,2.9ZM27.5,78.4c.8-.8,2.2-2.2,2.9-2.9h26.6l2.9,2.9H27.5ZM57.5,10.9c.8-.8,2.2-2.2,2.9-2.9v69.8l-2.9-2.9V10.9ZM65.7,1.7l-5,5c-16.5,0-33.4,0-34,0-1.3-1.3-3.7-3.7-5-5h44ZM26.6,79.2c22.7,0,33.6,0,34,0,1.3,1.3,3.7,3.7,5,5H21.7l5-5Z"
      />

      {props.show_diagram && (
        <>
          <line
            x1={x(0.48)}
            y1={y(-0.01)}
            x2={x(0.48)}
            y2={y(0.994)}
            stroke={lineColor}
            strokeWidth=".1"
          />
          <line
            x1={x(0.46)}
            y1={y(-0.01)}
            x2={x(0.5)}
            y2={y(-0.01)}
            stroke={lineColor}
            strokeWidth=".1"
          />
          <line
            x1={x(0.46)}
            y1={y(0.994)}
            x2={x(0.5)}
            y2={y(0.994)}
            stroke={lineColor}
            strokeWidth=".1"
          />
          <rect
            x={lengthX}
            y={lengthY}
            width="20"
            height="11"
            rx="0.8"
            fill="white"
          />
          <text
            x={lengthX + 2}
            y={lengthY + 4}
            fontSize=".4rem"
            stroke={lineColor}
            strokeWidth="0.01"
          >
            Length:
          </text>
          <text
            x={lengthX + 1}
            y={lengthY + 10}
            fontSize=".4rem"
            stroke={lineColor}
            strokeWidth="0.01"
          >
            {props.diamond.Measurement1}
          </text>

          <line
            x1={x(0.16)}
            y1={y(0.5)}
            x2={x(0.81)}
            y2={y(0.5)}
            stroke={lineColor}
            strokeWidth=".1"
          />
          <line
            x1={x(0.16)}
            y1={y(0.48)}
            x2={x(0.16)}
            y2={y(0.52)}
            stroke={lineColor}
            strokeWidth=".1"
          />
          <line
            x1={x(0.81)}
            y1={y(0.48)}
            x2={x(0.81)}
            y2={y(0.52)}
            stroke={lineColor}
            strokeWidth=".1"
          />

          <rect
            x={widthX}
            y={widthY}
            width="19"
            height="11"
            rx="0.8"
            fill="white"
          />
          <text
            x={widthX + 2}
            y={widthY + 4}
            fontSize=".4rem"
            stroke={lineColor}
            strokeWidth="0.01"
          >
            Width:
          </text>
          <text
            x={widthX + 1}
            y={widthY + 10}
            fontSize=".4rem"
            stroke={lineColor}
            strokeWidth="0.01"
          >
            {props.diamond.Measurement2}
          </text>
        </>
      )}
    </svg>
  );
};

export default Rectangle;
